import { FC } from 'react';
import { Link } from 'react-router-dom';

import Button from 'components/_core/Button';
import Tooltip from 'components/_core/Tooltip';

import * as routes from '../../../../routes';
import { ESTIMATION_TAX_FORECAST_PERIOD_ID } from '../../flows/microEstimation';
import { ESTIMATION_REVENUE_EDIT } from '../../flows/microEstimation/components/MicroEstimationFlow';
import locales from './locales';

interface EditPeriodButtonProps {
  isPaid: boolean;
  taxForecastPeriodId: string;
  isFromHistory?: boolean;
  onClick?: () => void;
}

const EditPeriodButton: FC<EditPeriodButtonProps> = ({
  isFromHistory = false,
  isPaid,
  onClick,
  taxForecastPeriodId,
}) => {
  const variant = isFromHistory ? 'secondary' : 'primary';
  return isPaid ? (
    <Tooltip description={locales.isPaid}>
      <Button
        icon="edit"
        iconPosition="left"
        isDisabled={true}
        variant={variant}
      >
        {locales.edit}
      </Button>
    </Tooltip>
  ) : (
    <Button
      as={Link}
      icon="edit"
      iconPosition="left"
      onClick={onClick}
      to={`${routes.microEstimationFlow}?${ESTIMATION_REVENUE_EDIT}=true&${ESTIMATION_TAX_FORECAST_PERIOD_ID}=${taxForecastPeriodId}`}
      variant={variant}
    >
      {locales.edit}
    </Button>
  );
};

export default EditPeriodButton;
